import axios from "axios";
import { HOST } from "config/config";
import tableDataQueryStringBuilder from "utils/tableData";

export function getGroupTargets(tableDataParam, forceRefresh = false) {
  return (dispatch, getState) => {
    if (!getState().groupTargetsReducer.updating || forceRefresh) {
      if (tableDataParam === undefined) {
        return dispatch({
          type: "GET_GROUP_TARGETS_PENDING",
          payload: axios
            .get(`${HOST}/api/group-targets`)
            .then(response => response.data)
            .then(json =>
              dispatch({
                type: "GET_GROUP_TARGETS_FULFILLED",
                payload: {
                  items: json
                }
              })
            )
            .catch(error =>
              dispatch({
                type: "SHOW_MESSAGE",
                payload: {
                  type: "error",
                  titleKey: "error",
                  message: error.message
                }
              })
            )
        });
      }

      return dispatch({
        type: "GET_GROUP_TARGETS_PENDING",
        payload: axios
          .get(`${HOST}/api/group-targets`, {
            paramsSerializer: params => tableDataQueryStringBuilder(params),
            params: tableDataParam
          })
          .then(response => response.data)
          .then(json => {
            if (tableDataParam) {
              dispatch({
                type: "UPDATE_GROUP_TARGETS_TABLEDATAPARAM",
                payload: tableDataParam
              });
            }

            dispatch({
              type: "GET_GROUP_TARGETS_FULFILLED",
              payload: json
            });
          })
          .catch(error =>
            dispatch({
              type: "GET_GROUP_TARGETS_REJECTED",
              payload: error
            })
          )
      });
    }
  };
}

export function getGroupTargetsForSelect() {
  return (dispatch, getState) => {
    if (!getState().groupTargetsReducer.updating) {
      return dispatch({
        type: "GET_GROUP_TARGETS_PENDING",
        payload: axios
          .get(`${HOST}/api/group-targets`)
          .then(response => response.data)
          .then(json =>
            dispatch({
              type: "GET_GROUP_TARGETS_SELECT_FULFILLED",
              payload: json
            })
          )
          .catch(error =>
            dispatch({
              type: "SHOW_MESSAGE",
              payload: {
                type: "error",
                titleKey: "error",
                message: error.message
              }
            })
          )
      });
    }
  };
}

export function getGroupTarget(groupTargetId, forceRefresh = false) {
  return (dispatch, getState) => {
    if (!getState().groupTargetsReducer.updating || forceRefresh) {
      if (groupTargetId === 0) {
        return dispatch({
          type: "GET_GROUP_TARGET_FULFILLED",
          payload: {
            id: 0,
            internalName: "",
            nameFrench: "",
            nameEnglish: "",
            createdDate: new Date()
          }
        });
      }
      return dispatch({
        type: "GET_GROUP_TARGET_PENDING",
        payload: axios
          .get(`${HOST}/api/tax-type-targets/${groupTargetId}`)
          .then(response => response.data)
          .then(json =>
            dispatch({
              type: "GET_GROUP_TARGET_FULFILLED",
              payload: json
            })
          )
          .catch(error =>
            dispatch({
              type: "GET_GROUP_TARGET_REJECTED",
              payload: error
            })
          )
      });
    }
  };
}

export function updateGroupTarget(groupTarget) {
  return dispatch =>
    dispatch({
      type: "UPDATE_GROUP_TARGET",
      payload: groupTarget
    });
}

export function persistGroupTarget(groupTarget) {
  return (dispatch, getState) => {
    if (!getState().groupTargetsReducer.updating) {
      return new Promise((resolve, reject) =>
        dispatch({
          type: "PERSISTING_GROUP_TARGET",
          payload: (groupTarget.id === 0
            ? axios.post(`${HOST}/api/group-targets`, groupTarget)
            : axios.put(`${HOST}/api/group-targets/${groupTarget.id}`, groupTarget)
          )
            .then(response => response.data)
            .then(json => {
              dispatch({
                type: "PERSISTED_GROUP_TARGET",
                payload: {
                  taxTypeTarget: json,
                  isNew: groupTarget.id === 0
                }
              });

              dispatch({
                type: "SHOW_MESSAGE",
                payload: {
                  type: "success",
                  titleKey: "success",
                  messageKey: "saved_successful"
                }
              });
              return resolve();
            })
            .catch(error => {
              dispatch({
                type: "SHOW_MESSAGE",
                payload: {
                  type: "error",
                  titleKey: "error",
                  message: error.response
                }
              });
              return reject();
            })
        })
      );
    }
  };
}
